import { FieldConfig } from "../components/addEmailPasswordModal";

// Field configurations for "Add" mode
export const addModeField1: FieldConfig = {
  id: "email",
  label: "Email",
  placeholder: "Enter email address",
  required: true,
};

export const addModeField2: FieldConfig = {
  id: "secretId",
  label: "Secret ID",
  placeholder: "Enter secret ID",
  required: true,
};

// Field configurations for "Edit" mode
export const getEditModeField1 = (secretIdValue: string): FieldConfig => ({
  id: "secretId",
  label: "Secret ID",
  defaultValue: secretIdValue,
  readOnly: true,
  required: false,
});

export const editModeField2: FieldConfig = {
  id: "appPassword",
  label: "App Password",
  placeholder: "Enter app password",
  required: true,
};
